import { createAction, props } from '@ngrx/store';
import { Notification, ReadState } from './notifications.model';


export const setNotifications = createAction('[Notif] Add notifications', props<{ notifications: Notification[] }>());

export const loadNotifications = createAction('[Notif] Load notifications from backend');

export const requestChangeReadState = createAction('[Notif] Request Change Read State', props<{ notifications: ReadState[]}>());

export const changeReadState = createAction('[Notif] Change Read State', props<{ notifications: ReadState[]}>());

export const changeOnlyUnread = createAction('[Notif] Change Only Unread', props<{ unread: boolean }>());

export const hideNotification = createAction('[Notif] Hide notifications', props<{ notificationId: string }>());

export const requestHideNotification = createAction('[Notif] Request hide notifications', props<{ notificationId: string }>());

export const requestSendEmails = createAction('[Notif] Request Send Email', props<{ enabled: boolean }>());

export const requestRecurrenceMonths = createAction('[Notif] Request Recurrence Months', props<{ months: number }>());
